import { render } from "./QuizTable.vue?vue&type=template&id=061100a1&scoped=true"
import script from "./QuizTable.vue?vue&type=script&lang=js"
export * from "./QuizTable.vue?vue&type=script&lang=js"

import "./QuizTable.vue?vue&type=style&index=0&id=061100a1&scoped=true&lang=css"

import exportComponent from "/home/nils/assessment_tool/code/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-061100a1"]])

export default __exports__